<div class="file-upload-download-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Select Option</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form style="margin-top: 1rem;">
        
        <!-- First Dropdown -->
        <mat-form-field appearance="fill" class="dropdown-field">
          <mat-label>Select an Option</mat-label>
          <mat-select [(value)]="selectedOption" (selectionChange)="onOptionSelect($event.value)">
            <mat-option *ngFor="let option of options" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field>
        
        <!-- Conditional Second Dropdown or Input -->
        <div *ngIf="selectedOption" style="margin-top: 1rem;">
          <ng-container *ngIf="optionDetails[selectedOption]?.length > 0; else showInputBox">
            <mat-form-field appearance="fill" class="dropdown-field">
              <mat-label>Select Detail</mat-label>
              <mat-select [(value)]="selectedDetail">
                <mat-option *ngFor="let detail of optionDetails[selectedOption]" [value]="detail">{{ detail }}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-template #showInputBox>
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <mat-form-field appearance="fill" class="add-details-field">
                <mat-label>Add New Detail</mat-label>
                <input matInput name="add-details-field" [(ngModel)]="newDetailValue" placeholder="Enter new value">
              </mat-form-field>
              <button mat-raised-button color="primary" (click)="onAddValue()">Add Value</button>
            </div>
            <!-- Display Added Values -->
            <div *ngIf="newDetailValues.length > 0">
              <mat-chip-set>
                <mat-chip *ngFor="let value of newDetailValues; let i = index" (removed)="removeValue(i)">
                  {{ value }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              </mat-chip-set>
              <button mat-raised-button color="primary" (click)="addNewDetail()">Add All</button>
            </div>
          </ng-template>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <button mat-raised-button color="primary" [disabled]="!selectedOption" (click)="onDownload()">
            <mat-icon>download</mat-icon> Download
          </button>
          <button mat-raised-button [disabled]="!selectedOption || !downloaded" (click)="fileInput.click()">
            <mat-icon>upload</mat-icon> Upload
          </button>
          <input type="file" #fileInput style="display: none" (change)="onFileUpload($event)" />
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
